/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetLinkingFormDriverPicker: "asset-linking-form-driver-picker",
  assetLinkingFormDriverSearch: "asset-linking-form-driver-search",
  assetLinkingFormTractorPicker: "asset-linking-form-tractor-picker",
  assetLinkingFormTractorSearch: "asset-linking-form-tractor-search",
  assetLinkingFormTrailerPicker: "asset-linking-form-trailer-picker",
  assetLinkingFormTrailerSearch: "asset-linking-form-trailer-search",
  assetLinkingFormPupTrailersPicker: "asset-linking-form-pup-trailers-picker",
  assetLinkingFormPupTrailersSearch: "asset-linking-form-pup-trailers-search",
  assetLinkingForm1Shift: "asset-linking-form-1-shift",
  assetLinkingForm1Day: "asset-linking-form-1-day",
  assetLinkingForm1Week: "asset-linking-form-1-week",
  assetLinkingFormPermanent: "asset-linking-form-permanent",
} as const;
